import React from 'react';
import { Separator, Table, TableCell, TableRow, Text } from 'telia-front-react';
import { useGo3AppDetails } from './Go3AppDetailsProvider';
export const Go3AppInclusions = () => {
    const { getApp } = useGo3AppDetails();
    const app = getApp();
    const content = app.appInfo.content;
    return (React.createElement(Text, null,
        React.createElement("p", { className: "h4" },
            React.createElement("strong", null, content.title)),
        React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
        content.sections.map((section, sectionIndex) => (React.createElement("div", { key: sectionIndex },
            React.createElement(Table, null,
                React.createElement("thead", null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { padding: "small", type: 'th', colSpan: 2 },
                            React.createElement("strong", null, section.title)))),
                React.createElement("tbody", null,
                    section.items.map((_, itemIndex) => {
                        var _a;
                        if (itemIndex % 2 === 0) {
                            return (React.createElement(TableRow, null,
                                React.createElement(TableCell, { padding: "small" }, section.items[itemIndex].text),
                                React.createElement(TableCell, { padding: "small" }, (_a = section.items[itemIndex + 1]) === null || _a === void 0 ? void 0 : _a.text)));
                        }
                        else {
                            return null;
                        }
                    }),
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: 2 })))))))));
};
